class ujAdatlapUjarvalaszto {

    constructor() {
        window.ujAdatlapUjarvalaszto = this;
        this.termekadatlapWrapperClass = $(".termekadatlap-wrapper-v2026").length > 0 ? ".termekadatlap-wrapper-v2026" : ".termekadatlap-wrapper";
        window.addEventListener('hashchange', () => {
            this.selectKiszerelesFromUrl();
        });

    }

    selectKiszerelesFromUrl() {
        if (!this.termekadatlapWrapperClass || $(this.termekadatlapWrapperClass).length === 0) {
            this.termekadatlapWrapperClass = $(".termekadatlap-wrapper-v2026").length > 0 ? ".termekadatlap-wrapper-v2026" : ".termekadatlap-wrapper";
        }

        var rawCandidates = [];
        var hash = '';
        if (window.location.hash) {
            hash = window.location.hash.replace(/^#/, '');
        } else if (document.location.href.indexOf('#') !== -1) {
            hash = document.location.href.split('#')[1];
        }

        if (hash) {
            if (hash.indexOf('=') !== -1) {
                try {
                    var hashParams = new URLSearchParams(hash);
                    var kParam = hashParams.get('k') || hashParams.get('kiszereles');
                    if (kParam) {
                        rawCandidates.push(kParam);
                    }
                } catch (e) { }
            } else {
                rawCandidates.push(hash);
            }
        }

        try {
            var urlParams = new URLSearchParams(window.location.search);
            var qParam = urlParams.get('k') || urlParams.get('kiszereles');
            if (qParam) {
                rawCandidates.push(qParam);
            }
        } catch (e) { }

        if (rawCandidates.length === 0) {
            return false;
        }

        var searchValues = [];
        for (var i = 0; i < rawCandidates.length; i++) {
            var raw = rawCandidates[i];
            if (!raw) continue;
            var clean = decodeURIComponent(raw).trim();
            if (!clean) continue;

            if (searchValues.indexOf(clean) === -1) {
                searchValues.push(clean);
            }

            if (/^k/i.test(clean)) {
                var withoutK = clean.replace(/^k/i, '');
                if (withoutK && searchValues.indexOf(withoutK) === -1) {
                    searchValues.push(withoutK);
                }
            } else {
                var withK = 'k' + clean;
                if (searchValues.indexOf(withK) === -1) {
                    searchValues.push(withK);
                }
            }

            var numMatch = clean.replace(/^k/i, '');
            if (/^\d+$/.test(numMatch)) {
                if (searchValues.indexOf(numMatch + 'g') === -1) searchValues.push(numMatch + 'g');
                if (searchValues.indexOf(numMatch + 'ml') === -1) searchValues.push(numMatch + 'ml');
            } else if (/^\d+(g|ml)$/i.test(numMatch)) {
                var numOnly = numMatch.replace(/(g|ml)$/i, '');
                if (searchValues.indexOf(numOnly) === -1) searchValues.push(numOnly);
            }
        }

        var $container = $('.cart-select-box .kiszereles-darabszam-select-kont');
        if ($container.length === 0) {
            $container = $(this.termekadatlapWrapperClass + ' .kiszereles-darabszam-select-kont:not(.cartbutton-cont)');
        }
        if ($container.length === 0) {
            $container = $('.kiszereles-darabszam-select-kont:not(.cartbutton-cont)');
        }

        if ($container.length === 0) {
            return false;
        }

        for (var j = 0; j < searchValues.length; j++) {
            var val = searchValues[j];
            var $match = $container.find('a[data-kiszereles_type="' + val + '"]');
            if ($match.length > 0) {
                this.changeKiszereles($match[0]);
                $match.trigger('click');
                return true;
            }
        }

        return false;
    }

    initHamarosanrendelheto() {
        if ($('.main-content.ujadatlap .product-details .cart-ujadatlap .cart-select-box .hamarosan-rendelheto').length > 0) {
            $('.main-content.ujadatlap .product-details .cart-ujadatlap').addClass('hamarosan-rendelheto-state')
        } else {
            $('.main-content.ujadatlap .product-details .cart-ujadatlap').removeClass('hamarosan-rendelheto-state')
        }

        this.selectKiszerelesFromUrl();
    }

    changeDarab(el, fixDB) {
        if ($(this.termekadatlapWrapperClass + ' .right-panel').length > 0) {
            var baseInput = $(this.termekadatlapWrapperClass + ' .right-panel .darabszam-input-kont .darabszam-input input');
            var selectedKiszerelesType = $(baseInput).data('aktkiszereles');
            var baseArakPanel = $(this.termekadatlapWrapperClass + ' .right-panel .kiszereles-ar[data-kiszereles="' + selectedKiszerelesType + '"]');
        } else {
            var baseInput = $('.cart-select-box .kiszereles-darabszam-select-kont .darabszam-input-kont .darabszam-input input');
            var selectedKiszerelesType = $(baseInput).data('aktkiszereles');
            var baseArakPanel = $('.kiszereles-arak-kont .kiszereles-ar[data-kiszereles="' + selectedKiszerelesType + '"]');
        }

        if (!fixDB) {
            var aktDarabszam = +$(baseInput).val();

            if ($(el).hasClass('plus')) {

                if (
                    $("html").data('locale') == 'en_AU'
                    || $("html").data('locale') == 'fr_FR'
                ) {
                    var kiszRaktarkeszlet = $(baseArakPanel).data('raktarkeszlet')
                    if (kiszRaktarkeszlet != '' && +kiszRaktarkeszlet > 0) {
                        aktDarabszam = Math.min(kiszRaktarkeszlet, aktDarabszam + 1);
                        if (aktDarabszam >= kiszRaktarkeszlet) {
                            aktDarabszam = kiszRaktarkeszlet;
                            $(el).addClass('disable-button');
                        }
                    } else {
                        aktDarabszam += 1;
                    }
                } else if ($("html").data('locale') == 'hu_HU') {

                    if ($(el).parents('.cart-select-box').find('.pontert-megvasarolom').length > 0) {
                        aktDarabszam += 1;

                        var max_order_limit = +$(el).parents('.cart-select-box').find('.pontert-megvasarolom .price').data('max_order_limit');
                        var maxLimit = +max_order_limit;

                        if (maxLimit > 0) {
                            // aktDarabszam = Math.min(maxLimit, aktDarabszam + 1);
                            if (aktDarabszam > maxLimit) {
                                $(el).parents('.cart-select-box').find('.pontert-megvasarolom .btn').addClass('btn-disabled').attr('disabled', 'disabled');
                            } else {
                                $(el).parents('.cart-select-box').find('.pontert-megvasarolom .btn').removeClass('btn-disabled').removeAttr('disabled');
                            }
                        } else {
                            $(el).parents('.cart-select-box').find('.pontert-megvasarolom .btn').removeClass('btn-disabled').removeAttr('disabled');
                        }
                    } else {
                        aktDarabszam += 1;
                    }
                } else {
                    aktDarabszam += 1;
                }

            } else {
                if (aktDarabszam > 1) {
                    $(el).parents('.darabszam-input').find('.plus').removeClass('disable-button');
                    aktDarabszam -= 1;
                }
            }

            if (isNaN(+baseInput.val())) {
                aktDarabszam = 1;
            }


            $(baseInput).val(aktDarabszam)

        } else {
            var aktDarabszam = fixDB;
        }




        var arSzamol = $(baseArakPanel).find('[data-calculate]')

        if (arSzamol.length > 0) {
            var arMin = 99999, arMax = 0;
            $.each(arSzamol, function (i, inp) {
                var arValue = +$(inp).data('calculate');

                if (arValue > 0) {
                    arMin = Math.min(arMin, arValue);
                    arMax = Math.max(arMax, arValue);

                    var newValue = 0;
                    var newValue_text = "";

                    newValue = aktDarabszam * arValue;

                    if ($(inp).data('type-point') == 1) {
                        newValue_text = Kosar.number_format(newValue, 0, ".", " ");
                    } else {
                        if ($("html").data('locale') == 'hu_HU') {
                            newValue_text = Kosar.number_format(newValue, 0, ".", " ") + " Ft";
                        } else if ($("html").data('locale') == 'de_DE') {
                            newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                        } else if ($("html").data('locale') == 'sk_SK') {
                            newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                        } else if ($("html").data('locale') == 'sl_SI') {
                            newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                        } else if ($("html").data('locale') == 'en_EU') {
                            newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                        } else if ($("html").data('locale') == 'fr_FR' || $("html").data('locale') == 'fr_BE') {
                            newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                            newValue_text = newValue_text.replace(",00", "");
                        } else if ($("html").data('locale') == 'cs_CZ') {
                            newValue_text = Kosar.number_format(newValue, 0, ",", " ") + " Kč";
                        } else if ($("html").data('locale') == 'pl_PL') {
                            newValue_text = Kosar.number_format(newValue, 2, ",", " ") + " zł";
                        } else if ($("html").data('locale') == 'en_US') {
                            newValue_text = '$' + Kosar.number_format(newValue, 2, ".", ",");
                        } else if ($("html").data('locale') == 'en_AU') {
                            newValue_text = '$' + Kosar.number_format(newValue, 2, ".", ",");
                        }
                    }

                    $(inp).find('span').text(newValue_text);
                }

            })

            $.each(arSzamol, function (i, inp) {
                if ($(inp).data('alkedvezmeny') == 1) {
                    var newValue_text = "";
                    var newValue = (arMax - arMin) * aktDarabszam;

                    if ($("html").data('locale') == 'hu_HU') {
                        newValue_text = Kosar.number_format(newValue, 0, ".", " ") + " Ft";
                    } else if ($("html").data('locale') == 'de_DE') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'sk_SK') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'sl_SI') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'en_EU') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'fr_FR' || $("html").data('locale') == 'fr_BE') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                        newValue_text = newValue_text.replace(",00", "");
                    } else if ($("html").data('locale') == 'cs_CZ') {
                        newValue_text = Kosar.number_format(newValue, 0, ",", " ") + " Kč";
                    } else if ($("html").data('locale') == 'pl_PL') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", " ") + " zł";
                    } else if ($("html").data('locale') == 'en_US') {
                        newValue_text = '$' + Kosar.number_format(newValue, 2, ".", ",");
                    } else if ($("html").data('locale') == 'en_AU') {
                        newValue_text = '$' + Kosar.number_format(newValue, 2, ".", ",");
                    }

                    $(inp).find('span').text(newValue_text);
                }
            });

            var tarValMax = arMax * aktDarabszam;

            if ($('#utalvanyertekszorzo').length == 0) {
                $('[name="akt_termek_ar"]').val(tarValMax);
            }

            $('[name="akt_termek_klub_ar"]').val(arMin * aktDarabszam);
        }

        return false
    }

    keyupDarab(ev) {
        var baseInput = $('.cart-select-box .kiszereles-darabszam-select-kont .darabszam-input-kont .darabszam-input input');

        var pressed = ev.which || ev.keyCode;

        // felnyil
        if (pressed == 38) {
            var aktDarabszam = +$(baseInput).val();
            aktDarabszam += 1;
            $(baseInput).val(aktDarabszam)

            // lenyil
        } else if (pressed == 40) {
            var aktDarabszam = +$(baseInput).val();
            if (aktDarabszam > 1) {
                aktDarabszam -= 1;
            }
            $(baseInput).val(aktDarabszam)
        }

        if (isNaN(+baseInput.val())) {
            $(baseInput).val(1)
        }

        try {
            ujAdatlapUjarvalaszto.changeDarab($('.cart-select-box .kiszereles-darabszam-select-kont .darabszam-input-kont .plus'), +baseInput.val());
        } catch (e) {
            // console.log(e)
        }

    }

    changeKiszereles(el) {
        try {
            this.changeKiszerelesEvent(el);
        } catch (e) {
            // console.log(e)
        }
        var aktKiszId = $(el).data('kiszereles_id');



        if ($(".mainpicture-kont [data-kiszereles_id=" + aktKiszId + "]").length > 0) {

            $(".mainpicture-kont [data-kiszereles_id]").addClass('noshow');

            $(".mainpicture-kont [data-kiszereles_id=" + aktKiszId + "]").removeClass('noshow');
        }

        if (typeof kiszid != "undefined" && kiszid != '') {
            ujAdatlapUjarvalaszto.changeKiszerelesEvent($('.cart-ujadatlap .kiszereles-selectors .kiszerelesek-kont a[data-kiszereles_id=' + kiszid + ']'));
        }

        console.log(window, ujAdatlapUjarvalaszto.toggleMenyikedvInfo)
        try {
            ujAdatlapUjarvalaszto.toggleMenyikedvInfo(aktKiszId);
        } catch (e) {
            // console.log(e)
        }

        return false
    }

    changeKiszerelesEvent(el) {
        $(el).parent().find('a').removeClass('selected');
        $(el).addClass('selected');

        var aktKiszType = $(el).data('kiszereles_type'),
            aktKiszId = $(el).data('kiszereles_id'),
            baseInput = $('.cart-select-box .kiszereles-darabszam-select-kont .darabszam-input-kont .darabszam-input input');

        if ($(this.termekadatlapWrapperClass + ' .right-panel').length > 0) {
            baseInput = $(this.termekadatlapWrapperClass + ' .right-panel .darabszam-input-kont .darabszam-input input');
        }
        baseInput.data('aktkiszereles', aktKiszType)
        $('.kiszereles-arak-kont .kiszereles-ar').addClass('hide');
        $('.kiszereles-arak-kont .kiszereles-ar[data-kiszereles="' + aktKiszType + '"]').removeClass('hide');

        try {
            if ($(this.termekadatlapWrapperClass + ' .right-panel').length > 0) {
                this.changeDarab($(this.termekadatlapWrapperClass + ' .right-panel .darabszam-input-kont .darabszam-input .plus'), +baseInput.val());
            } else {
                this.changeDarab($('.cart-select-box .kiszereles-darabszam-select-kont .darabszam-input-kont .plus'), +baseInput.val());
            }
            this.toggleMenyikedvInfo(aktKiszId);
        } catch (e) {
            // console.log(e)
        }

        let baseProdItem = $(el).parents('.cart-select-box');

        if ($(el).data('kiszereles_nincs_ar_erdeklodjon') == 1) {
            $(baseProdItem).find('.darabszam-input-kont, .kiszereles-arak-kont, .buttons, .mennyisegi-kedvezmenyek, .mennyisegi-kedvezmenyek-gombok').addClass('hide');
            console.log($(baseProdItem).find('.darabszam-input-kont, .kiszereles-arak-kont, .buttons, .mennyisegi-kedvezmenyek, .mennyisegi-kedvezmenyek-gombok'))
            $(baseProdItem).find('.nincs-ar-erdeklodjon').removeClass('hide');
        } else {
            $(baseProdItem).find('.darabszam-input-kont, .kiszereles-arak-kont, .buttons, .mennyisegi-kedvezmenyek, .mennyisegi-kedvezmenyek-gombok').removeClass('hide');
            $(baseProdItem).find('.nincs-ar-erdeklodjon').addClass('hide');
        }


        let aktKedvKiszBase = $('.kiszereles-arak-kont .kiszereles-ar[data-kiszereles="' + aktKiszType + '"]');

        if ($('.product-details .adatlap-picture-kont .akcio-aktiv').length > 0) {

            if (aktKedvKiszBase.length > 0) {
                if ($('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label', aktKedvKiszBase).length > 0) {
                    var szazTextBase = $('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label', aktKedvKiszBase), szazText = "";
                    if ($('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label span', aktKedvKiszBase).length > 0) {
                        szazTextBase = $('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label span', aktKedvKiszBase);
                    }
                    szazText = $.parseHTML(szazTextBase.html());
                    if (szazText.length > 0) {
                        szazText = $(szazText.shift()).text().trim().replace(/-/, "").replace(/%/, "");
                        $('.product-details .adatlap-picture-kont .akcio-aktiv span').text(szazText);
                    }
                }
            }
        }

        if ($(this.termekadatlapWrapperClass + ' .adatlap-bal .image-canvas .akcio-aktiv').length > 0) {
            console.log(aktKedvKiszBase, 'aktKedvKiszBase')
            if (aktKedvKiszBase.length > 0) {
                if ($('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label', aktKedvKiszBase).length > 0) {
                    var szazTextBase = $('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label', aktKedvKiszBase), szazText = "";
                    if ($('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label span', aktKedvKiszBase).length > 0) {
                        szazTextBase = $('.kedvezmeny-ar-kont .kedvezmeny-szazalek-label span', aktKedvKiszBase);
                    }
                    szazText = $.parseHTML(szazTextBase.html());
                    if (szazText.length > 0) {
                        szazText = $(szazText.shift()).text().trim().replace(/-/, "").replace(/%/, "");
                        $(this.termekadatlapWrapperClass + ' .adatlap-bal .image-canvas .akcio-aktiv span').text(szazText);
                    }
                }
            }
        }

        if (aktKedvKiszBase.length > 0) {
            if ($('.pontert-megvasarolom', aktKedvKiszBase).length > 0) {

                var pointvalue = +$('.price[data-calculate]', aktKedvKiszBase).data('calculate');
                console.log($('.price[data-calculate]', aktKedvKiszBase), pointvalue)
                if (pointvalue > 0) {
                    $('.pontert-megvasarolom', aktKedvKiszBase).removeClass('d-none');
                } else {
                    $('.pontert-megvasarolom', aktKedvKiszBase).addClass('d-none');
                }
            }
        }

        return false;
    }

    toggleMenyikedvInfo(aktKiszId) {
        if ($('.main-content.ujadatlap .mennyisegi-kedvezmenyek').length > 0) {
            let inaktKiszer = "" + $('.main-content.ujadatlap .mennyisegi-kedvezmenyek').data('inaktiv_kiszerelesek');
            let inaktKiszerData = inaktKiszer.split(',');

            $('.main-content.ujadatlap .mennyisegi-kedvezmenyek').removeClass('hide')
            $('.akcio-aktiv.egyedi-mintermek, .akcio-aktiv.egyedi-szazalek').removeClass('hide')

            if (inaktKiszerData.length > 0) {
                inaktKiszerData.forEach(function (inki) {
                    if (inki == aktKiszId) {
                        $('.main-content.ujadatlap .mennyisegi-kedvezmenyek').addClass('hide');
                        $('.akcio-aktiv.egyedi-mintermek, .akcio-aktiv.egyedi-szazalek').addClass('hide');
                    }
                });
            }

        }
    }

    initShow() {
        if (!this.selectKiszerelesFromUrl()) {
            let aktivKiszerelesekBase = $('.cart-ujadatlap .cart-select-box .kiszereles-selectors .kiszerelesek-kont');
            if ($('a[data-kiszereles_alapertelmezett="1"]', aktivKiszerelesekBase).length > 0) {
                $('a[data-kiszereles_alapertelmezett="1"]:first', aktivKiszerelesekBase).trigger('click');
            } else {
                $('a:first', aktivKiszerelesekBase).trigger('click');
            }
        }
    }

    kosarBarak(selectMode, el) {
        if (!selectMode) {
            var selectMode = ''
        }

        var datas = {}, maxNum = 0;

        datas['termek_id'] = $('input[name=termek_id]').val();
        datas['akt_termek_ar'] = $('[name="akt_termek_ar"]').val();
        datas['akt_termek_klub_ar'] = $('[name="akt_termek_klub_ar"]').val();
        datas['actcurrency'] = $('[name="actcurrency"]').val();
        datas['termek_data'] = {
            'kep': termekDirectData.felugro_kep,
            'nev': termekDirectData.felugro_nev
        };

        if (kozmetikaDesign) {
            datas["kozmetika"] = 1;
        }

        datas['sessdata'] = typeof shopSessData == 'undefined' ? '' : shopSessData;;

        // datas['debug'] = 1;

        if (selectMode == 'ajandekutalvany') {
            var baseInput = $('.cart-select-box .darabszam-input-kont .darabszam-input');
            var aktDarabszam = 1;
            datas['mode'] = 'ajandekutalvany';
        } else if (selectMode == 'szett') {

            Kosar.kosarFelugro = true;
            datas['mode'] = 'szett';
            datas['szett_id'] = $(el).data('szett_id');
            var aktDarabszam = 1;

            datas['szett_csomag'] = $(el).data('szett_csomag');

            var itemBase = $(el).parents('.cart-select-box');
            if (itemBase.find('.darabszam-input input').length > 0) {
                datas['db_14'] = itemBase.find('.darabszam-input input').val();
                aktDarabszam = datas['db_14'];
            }

            var baseInput = $('.cart-select-box .darabszam-input-kont .darabszam-input input');
            if ($('.main-content.ujadatlap .csomagtermek-adatok.szett-items-lista').length > 0) {
                baseInput = $('.main-content.ujadatlap .csomagtermek-adatok.szett-items-lista');
            }

            if ($(this.termekadatlapWrapperClass + ' .right-panel .kiszereles-arak-kont .klubar-kont .klubar-price .klubar-text').length > 0) {
                baseInput = $(this.termekadatlapWrapperClass + ' .right-panel .kiszereles-arak-kont .klubar-kont .klubar-price .klubar-text');
            }




        } else {

            var baseInput = $('.cart-select-box .darabszam-input-kont .darabszam-input input');
            var aktDarabszam = +$(baseInput).val();
            var selectedKiszerelesType = $(baseInput).data('aktkiszereles');

            datas['type_1'] = selectedKiszerelesType;
            datas['db_1'] = aktDarabszam;
        }
        if (window.location.href.indexOf('navi4') != -1) {
            datas["upsalev2"] = 1;
        }

        if ($(el).length > 0 && $(el).data('pontbevaltas')) {
            datas['pontbevaltas'] = 1;
        }

        var sidebarDisable = false;

        var cart = $('.webshop-button-d2');


        if (aktDarabszam > 0) {


            var elo = baseInput;

            var self = $(elo);
            var imgclone = self.clone()
                .addClass('shrink')
                .offset({ top: self.offset().top, left: self.offset().left })
                .css({ 'opacity': '0.5', 'position': 'absolute', 'overflow': 'hidden', 'z-index': '1000' })
                .appendTo($('body'));
            imgclone.animate({
                // 'width':0,
                // 'height':0,
                'top': cart.offset().top + 10,
                'left': cart.offset().left + 30
            }, 500, 'swing', function () {
                $(this).detach();
                $('.webshop-button-d2').addClass('changed');


                (function (datas, el) {

                    if (typeof GTAGDataItem != "undefined") {
                        GTMDataPusher.listItemAddToCart(GTAGDataItem, aktDarabszam);
                        GtagDataPusher.listItemAddToCart(GTAGDataItem, aktDarabszam);
                        FBQDataPusher.listItemAddToCart(GTAGDataItem, aktDarabszam);
                    }

                    $.post('/kosar/ad', datas, function (res) {

                        if (res.nincs_eleg_pont) {
                            sidebarDisable = true;

                            // if ($('.product-details').length > 0) {
                            //     $(el).parents('.pontert-megvasarolom').find('.no-points').removeClass('d-none');
                            //     setTimeout(function () {
                            //         $(el).parents('.pontert-megvasarolom').find('.no-points').addClass('d-none');
                            //     }, 3000);
                            // } else {
                            //     $(el).parents('.prices-kont').find('.no-points').removeClass('d-none');
                            //     setTimeout(function () {
                            //         $(el).parents('.prices-kont').find('.no-points').addClass('d-none');
                            //     }, 3000);
                            // }
                        } else {
                            $('.webshop-button-d2 .cart-num').text(res.kos.allproduct);

                            //$('.header .tools .shop .amount').text(res.kos.allproduct);
                            $('#kosarlink1 .amount, #kosarlink2 .amount, .header .tools .shop .amount').each(function () {
                                $(this).text(res.kos.allproduct);
                                if (+res.kos.allproduct > 9) {
                                    $(this).addClass('wider')
                                }
                            });

                            $(baseInput).val(1);
                            if ($('.cart-ujadatlap .kiszereles-selectors .kiszerelesek-kont a[data-kiszereles_alapertelmezett="1"]').length > 0) {
                                $('.cart-ujadatlap .kiszereles-selectors .kiszerelesek-kont a[data-kiszereles_alapertelmezett="1"]:first').trigger('click');
                            } else {
                                $('.kiszereles-arak-kont .kiszereles-ar:first').trigger('click');
                            }

                            $('#kosarlink1, #kosarlink2, #kosarlink3').attr('href', kosarShopURL);

                            //datas['res'] = res;
                            datas['posta_ingyenlimit'] = $('[name="posta_ingyenlimit"]').val() != "" ? $('[name="posta_ingyenlimit"]').val() : postaIngyenlimit;
                            datas['actcurrency'] = $('[name="actcurrency"]').val();

                            //window.location.reload()
                            //Kosar.loadIngyenlimit(datas);
                            Kosar.saveKosarToBrowser();
                        }

                        if (!sidebarDisable) {
                            setTimeout(function () {
                                $('.webshop-button-d2').removeClass('changed');

                                Kosar.showSelectdialog(datas);

                            }, 1100);
                        }
                    });
                })(datas, el);


            });
        } else {

            $(baseInput).parent().addClass('shake-shake');
            setTimeout(function () {
                $(baseInput).parent().removeClass('shake-shake');
            }, 1100);
        }

        return false
    }
}

// window["ujAdatlapUjarvalaszto"] = {
//     initHamarosanrendelheto: ujAdatlapUjarvalaszto.initHamarosanrendelheto,
//     changeDarab: ujAdatlapUjarvalaszto.changeDarab,
//     keyupDarab: ujAdatlapUjarvalaszto.keyupDarab,
//     changeKiszereles: ujAdatlapUjarvalaszto.changeKiszereles,
//     changeKiszerelesEvent: ujAdatlapUjarvalaszto.changeKiszerelesEvent,
//     toggleMenyikedvInfo: ujAdatlapUjarvalaszto.toggleMenyikedvInfo,
//     initShow: ujAdatlapUjarvalaszto.initShow,
//     kosarBarak: ujAdatlapUjarvalaszto.kosarBarak
// }

export default ujAdatlapUjarvalaszto;
